import { toast } from 'react-toastify';
import { translateApiError } from './translateApiError';

let isIntercepted = false;

/**
 * Automatically intercepts all `toast.error(...)` calls across the entire application.
 * Any raw backend error code (e.g., "CLASS_PRIMARY_TEACHER_EXISTS") or Error object
 * will be automatically translated into the active language (Arabic / English).
 */
export function setupToastInterceptor() {
  if (isIntercepted) return;
  isIntercepted = true;

  const originalError = toast.error.bind(toast);

  toast.error = (content, options) => {
    let translatedContent = content;

    try {
      if (content !== null && content !== undefined) {
        translatedContent = translateApiError(content);
      }
    } catch (e) {
      console.error('Error in toastInterceptor:', e);
    }

    return originalError(translatedContent, options);
  };
}
